import { Paper, Box, Typography } from "@mui/material";
import { scaleIn } from "./animations";

const StatsCard = ({
  label,
  value,
  subtitle,
  icon: Icon,
  bgColor,
  iconColor,
  index = 0,
  variant = "default", // "default" or "compact"
}) => {
  if (variant === "compact") {
    return (
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          p: 2.5,
          borderRadius: 3,
          border: "1px solid #E2E8F0",
          bgcolor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: 2,
          animation: `${scaleIn} 0.4s ease-out ${index * 0.1}s both`,
          cursor: "pointer",
          transition: "all 0.2s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
            borderColor: iconColor,
          },
        }}
      >
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: 3,
            bgcolor: bgColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "transform 0.2s ease",
          }}
        >
          <Icon sx={{ fontSize: 26, color: iconColor }} />
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 700,
              color: "#94A3B8",
              fontStyle: "bold",
              textTransform: "uppercase",
              letterSpacing: 0.5,
              mb: 0.5,
            }}
          >
            {label}
          </Typography>
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: 700,
              color: "#1E293B",
              lineHeight: 1,
            }}
          >
            {value}
          </Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        p: 2.5,
        borderRadius: 4,
        border: "1px solid #E2E8F0",
        bgcolor: "#fff",
        animation: `${scaleIn} 0.4s ease-out ${index * 0.1}s both`,
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          borderColor: iconColor,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: 12,
              fontStyle: "bold",
              fontWeight: 700,
              color: "#64748B",
              textTransform: "uppercase",
              letterSpacing: 0.5,
              mb: 0.75,
            }}
          >
            {label}
          </Typography>
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: 700,
              color: "#1E293B",
              lineHeight: 1,
              mb: 0.5,
            }}
          >
            {value}
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: 12, color: "#94A3B8" }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            width: 24,
            height: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "transform 0.2s ease",
          }}
        >
          <Icon sx={{ fontSize: 22, color: iconColor }} />
        </Box>
      </Box>
    </Paper>
  );
};

export default StatsCard;
